import { render, staticRenderFns } from "./DeletedCustomerList.vue?vue&type=template&id=fd984592&scoped=true&"
import script from "./DeletedCustomerList.vue?vue&type=script&lang=js&"
export * from "./DeletedCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd984592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
